@use '@design/design-tokens/typography/typography' as *;
@use '@design/components/custom-scroll/custom-scroll' as *;

$footer-height: 56px;

.drawer {
  --z-index-drawer: var(--z-index-modal);
}

.content {
  @include custom-scroll-minimal;
  overflow-y: auto;
  height: calc(100% - $footer-height);
  padding: 20px 20px 80px;

  &.noFooter {
    height: 100%;

    &::after {
      bottom: 0;
    }
  }
}

.footer {
  width: 100%;
  height: $footer-height;
  padding: 0 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid var(--border-soft);
  position: relative;

  svg {
    fill: var(--icon-primary);
  }
}

.errorMessage {
  border: none;
  display: flex;
}

.dowJonesDisclaimer {
  @include typography-v2-body-xs;
  color: var(--text-soft);
}
